import { render, staticRenderFns } from "./CardsInTwoColumns.vue?vue&type=template&id=a5a8cec2&scoped=true&"
import script from "./CardsInTwoColumns.vue?vue&type=script&lang=ts&"
export * from "./CardsInTwoColumns.vue?vue&type=script&lang=ts&"
import style0 from "./CardsInTwoColumns.vue?vue&type=style&index=0&id=a5a8cec2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a8cec2",
  null
  
)

export default component.exports